import { useTranslation } from 'react-i18next';
import { PlayIcon } from '@shared/ui';
import './hero.css';

/**
 * Блок тренировки на главной — верх карточки «Тренировка на сегодня» (рамку и строку серии даёт `TodayCard`,
 * новая главная 2026-10-22) с оранжевой кнопкой (набросок D, ТЗ главной § 11):
 * в покое на экране один яркий акцент — кнопка тренировки, а когда открыт лист словаря — «Создать».
 * Числа «к повторению» нет: такого в API нет. `phone` — раскладка телефона (страница берёт её из
 * useIsSidebarMobile).
 */
export function StudyHero({ onStart, phone = false }: { onStart: () => void; phone?: boolean }) {
  const { t } = useTranslation();

  if (phone) {
    return (
      <div className="dh-hero-phone flex flex-col p-4">
        <div className="text-[12px] font-semibold uppercase leading-4 tracking-[0.14em] text-muted">
          {t('training.kicker')}
        </div>
        <h2 className="mt-2 line-clamp-2 font-serif text-[22px] font-medium leading-[28px] tracking-[-0.01em] text-fg">
          {t('training.heroTitle')}
        </h2>
        <button
          type="button"
          data-tour="training"
          onClick={onStart}
          className="mt-auto flex h-12 w-full flex-none items-center justify-center gap-2.5 rounded-pill bg-accent text-[16px] font-semibold text-fg-inv transition-colors hover:bg-accent-hi"
        >
          <PlayIcon className="h-3.5 w-3.5" aria-hidden />
          {/* На узком экране «Начать тренировку» переносилось на две строки (решение владельца 2026-10-19). */}
          <span className="min-[380px]:hidden">{t('training.startShort')}</span>
          <span className="hidden min-[380px]:inline">{t('training.start')}</span>
        </button>
      </div>
    );
  }

  return (
    // dh-study — контейнер: подзаголовок показывается по ширине самой карточки (hero.css).
    <div className="dh-hero dh-study flex items-center gap-6 px-8">
      <div className="min-w-0 flex-1">
        <div className="text-[12px] font-semibold uppercase leading-4 tracking-[0.14em] text-muted">
          {t('training.kicker')}
        </div>
        <h2 className="mt-2 line-clamp-2 text-balance font-serif text-[28px] font-medium leading-[34px] tracking-[-0.01em] text-fg">
          {t('training.heroTitle')}
        </h2>
        <p className="dh-hero-sub mt-2 text-[14px] leading-5 text-muted">{t('training.heroSub')}</p>
      </div>
      <button
        type="button"
        data-tour="training"
        onClick={onStart}
        className="flex h-[52px] flex-none items-center gap-2.5 whitespace-nowrap rounded-pill bg-accent px-7 text-[16px] font-semibold text-fg-inv transition-colors hover:bg-accent-hi"
      >
        <PlayIcon className="h-3.5 w-3.5" aria-hidden />
        {t('training.start')}
      </button>
    </div>
  );
}
